export default "__VITE_ASSET__DgrUjy8M__"